import React, { useEffect, useState } from 'react';

import { Checkbox, Grid, IconButton, Input, InputAdornment, makeStyles, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import CaseStatusCell from './CaseStatusCell';
import { caseColors, caseStatuses } from '../../models/Case';

const useStyles = makeStyles(() => ({
  chkBoxSvg: {
    '& path': {
      outline: '3px solid rgba(0, 0, 0, 0.54)',
    },
  },
  list: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  menu: {
    border: '2px solid #E7E7E7',
    borderRadius: '5px',
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    paddingBottom: '1rem',
  },
}));

const statuses = { ...caseStatuses };
const renderSelectedStatusesLabel = (values) => {
  if (!values.length) return 'No Status';
  if (values.length === 1) return statuses[values[0]].label;
  if (values.length < Object.keys(statuses).length) return `${statuses[values[0]].label} + ${values.length - 1}`;
  return 'All Statuses';
};

export default ({ onCriteriaChange, defaultCaseStatus = [] }) => {
  const classes = useStyles();
  const [selectedFilter, setSelectedFilter] = useState(defaultCaseStatus);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    setSelectedFilter(defaultCaseStatus);
  }, [defaultCaseStatus]);

  const onFilterChange = (event) => {
    const selectedStatuses = event.target.value;
    setSelectedFilter(selectedStatuses);

    const status = selectedStatuses.length ? selectedStatuses.join(',') : 'empty';
    const isDueSoon = selectedStatuses.includes('delayed');

    onCriteriaChange({ isDueSoon: isDueSoon || null, status });
  };

  const onSearchChange = (event) => {
    setKeyword(event.target.value);
  };

  const onSearchClick = () => {
    onCriteriaChange({ keyword });
  };

  const renderFilterDropdown = () => (
    <Grid container item alignItems="center" justify="flex-start" xs={6}>
      <Typography>View:&nbsp;</Typography>
      <Select
        value={selectedFilter}
        onChange={onFilterChange}
        input={<Input disableUnderline />}
        renderValue={(val) => renderSelectedStatusesLabel(val)}
        displayEmpty
        multiple
        MenuProps={{
          anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom',
          },
          classes: {
            list: classes.list,
            paper: classes.menu,
          },
          getContentAnchorEl: null,
        }}>
        {[
          'pending-upload',
          'upload-shared',
          'pending-images',
          'new',
          'delayed',
          'uploading',
          'in-progress',
          'review',
          'in-review',
          'completed',
          'incomplete',
          'not-paid',
          'archived',
        ].map((key) => {
          const status = statuses[key];
          return (
            <MenuItem key={status.value} value={status.value} style={{ background: 'none', paddingBottom: 0, paddingTop: 0, width: '230px' }}>
              <Checkbox checked={selectedFilter.includes(status.value)} color="primary" />
              <CaseStatusCell color={caseColors[status.value]} status={status.label} />
            </MenuItem>
          );
        })}
      </Select>
    </Grid>
  );

  const renderSearchInput = () => (
    <Grid item container xs={6} justify="flex-end">
      <TextField
        onChange={onSearchChange}
        onKeyUp={(evt) => {
          if (evt.key === 'Enter') {
            onSearchClick();
          }
        }}
        placeholder="Search"
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton onClick={onSearchClick}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        type="text"
      />
    </Grid>
  );

  return (
    <Grid container justify="space-between">
      {renderFilterDropdown()}
      {renderSearchInput()}
    </Grid>
  );
};
